jQuery(document).ready(function($){

    // Setup keyboard nav for top dropdowns
    // Note: this needs to be done after the feature content injection
    var menuKeyboardNav = function() {
        // get all dropdowns from header
        var menuItem = document.querySelectorAll('#menu-top-persistent-menu > .menu-item-has-children, #top-primary-menu > .menu-item-has-children')

        menuItem.forEach(item => {
            var links = item.querySelectorAll('a')
            // show if focused on any link inside this menu-item
            links.forEach(link => {
                link.addEventListener('focus', event => item.classList.add('show'))
                link.addEventListener('blur', event => item.classList.remove('show'))
            })
        })
    }

    // Search Toggles
    const $searchForm = $('#desktop-search-form');
    const $searchFormClose = $('#desktop-search-close');
    const $searchFormTrigger = $('.js-search-toggle a');

    function toggleSearchForm(closeState) {
        $('.site-header').toggleClass('search-open');
        if ( closeState )
            $searchFormTrigger.focus();
        else
            $searchForm.children('.search-field').focus();
    }

    $searchFormClose.click(function(e) {
        e.preventDefault();
        toggleSearchForm(true);
    });

    $searchFormTrigger.click(function(e) {
        e.preventDefault();
        toggleSearchForm(false);
    });

    $searchForm.on('keydown', function(e) {
        if (e.keyCode === 27) { // escape arrow
            e.preventDefault();
            toggleSearchForm(true);
        }
    });

    // Mobile menu Toggles
    const $mobileMenu = $('.wp-block-template-part--mobile-navigation');
    const $menuMenuTrigger = $('#main-nav-toggle');
    const $mobileMenuTrigger = $('#mobile-nav-toggle');

    function toggleSidebar() {
        // $menuMenuTrigger.toggleClass('active');
        $mobileMenu.toggleClass('move-to-left');
        $('.site').toggleClass('menu-open');
        $('.site-header').toggleClass('move-site-header-left');
        $('body').toggleClass('restrict-overflow');
    }

    $menuMenuTrigger.on('click tap', function(e) {
        let triggerExpanded = $menuMenuTrigger.attr('aria-expanded') === 'true';
        $menuMenuTrigger.attr('aria-expanded', !triggerExpanded);
        $mobileMenuTrigger.attr('aria-expanded', !triggerExpanded);
        toggleSidebar();
        $mobileMenuTrigger.focus();
    });

    $mobileMenuTrigger.on('click tap', function(e) {
        let triggerExpanded = $mobileMenuTrigger.attr('aria-expanded') === 'true';
        $menuMenuTrigger.attr('aria-expanded', !triggerExpanded);
        $mobileMenuTrigger.attr('aria-expanded', !triggerExpanded);
        toggleSidebar();
    });

    $mobileMenu.keydown(function(e) {
        if (e.keyCode === 27) { // escape arrow
            e.preventDefault();
            toggleSidebar();
            $menuMenuTrigger.attr('aria-expanded', 'false');
            $mobileMenuTrigger.attr('aria-expanded', 'false');
            $menuMenuTrigger.focus();
        }
    });

    $('.main-navigation .menu-item-has-children').on('click', openSubmenu);
    $('.main-footer-menu .menu-item-has-children').on('click', openSubmenu);

    function openSubmenu(e) {
        if ($(window).width() > 1200) {
            return;
        }
        $(this).children('a').removeAttr('href');
        $('.open-submenu').not(this).removeClass('open-submenu');
        $(this).toggleClass('open-submenu');
    }

    $(window).resize( function() {
        if( $(this).width() > 1200 ) {
            $('.open-submenu').removeClass('open-submenu');
            // setNavWidths();
        } else {
        }
    });

    // Smooth Scrolling
    // Select all links with hashes
    $(function() {
        $('a[href*="#"]:not([data-rel^=lightcase])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    var masthead = $('#masthead'),
                        adminbar = $('#wpadminbar'),
                        offset = 0;
                    if ( masthead.length ) {
                        offset += masthead.outerHeight();
                    } else if ( adminbar.length ) {
                        offset += adminbar.outerHeight();
                    }
                    $('html,body').animate({
                        scrollTop: target.offset().top - offset
                    }, 1000);
                    return false;
                }
            }
        });
    });

    var menu = $('#site-navigation');
    var push = $('.nav-push');
    var headerPush = $('.mobile-header-push');
    $('#menu-toggle').click(function() {
        menu.toggleClass('menu-open');
        push.toggleClass('nav-push-right');
        headerPush.toggleClass('nav-push-right');
    });

    


    

    //lets add the observer element dynamically.
    var siteHeader = document.querySelector('.site-header');
    if (siteHeader) {
        var navObserverEl = document.createElement("div");
        navObserverEl.id = "stickyNavObserver";
        insertBefore(navObserverEl, siteHeader);
        function insertBefore(el, referenceNode) {
            referenceNode.parentNode.insertBefore(el, referenceNode);
        }

        var observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].intersectionRatio === 0) {
                    siteHeader.classList.add('is-sticky');
                } else if (entries[0].intersectionRatio === 1) {
                    siteHeader.classList.remove('is-sticky');
                }
            },
            { threshold: [0, 1] }
        );

        observer.observe( navObserverEl );
    }







    // const siteHeader = document.querySelector('.site-header');
    // let scrollEl = null;

    // // if ( document.body.classList.contains('admin-bar') ) {
    // //     scrollEl = document.querySelector("#wpadminbar");
    // // } else {
    //     scrollEl = document.body;
    // // }
    // const observer = new IntersectionObserver( 
    //     ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
    //     { 
    //         root: scrollEl,
    //         rootMargin: '-1px',
    //         threshold: [1] 
    //     }
    // );

    // observer.observe(siteHeader);

}); // End Doc Ready